import dayjs from "dayjs";


const dateWall = (ctx) => {
  return dayjs(ctx?.selectedDate).add(1, "d").subtract(ctx.delay ?? 0, "d").isAfter(dayjs());
};

export default dateWall;